import { defineComponent as _defineComponent } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const __default__ = require('@nuxtjs/composition-api').defineComponent({
  name: 'SchoolPlans',
  middleware({ store, i18n, redirect }: any) {
    const usersSecondaryLocation = store.getters.loggedInUser?.location?.secondary;
    if (
      store.getters.isAuthenticated &&
      usersSecondaryLocation &&
      usersSecondaryLocation !== i18n.locale
    ) {
      redirect('/' + usersSecondaryLocation + '/school/');
    }
  },
  jsonld() {
    // @ts-ignore
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      // @ts-ignore
      title: this.title,
      meta: [
        // @ts-ignore
        { hid: 'title', name: 'title', content: this.title },
        {
          hid: 'description',
          name: 'description',
          // @ts-ignore
          content: this.description,
        },
      ],
      // @ts-ignore
      link: this.$hrefLangsPage(this.$route),
    };
  },
});

import { onMounted, ref, useContext, useRoute } from '@nuxtjs/composition-api';
import TLinkButton from '~/components/atoms/t-link-button.vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const route = useRoute();

const title = ref('School Plans');
const description = ref(
  'Join thousands of other teachers and gain access to a library of unique, high quality teaching resources to brighten your classroom and engage your students'
);

expose({
  title,
  description,
});

return { __sfc: true,route, title, description, TLinkButton }
}

})